// extracted by mini-css-extract-plugin
export default {"LoginContainer":"ChangePassword_LoginContainer__1-I0M","FormInputContainer":"ChangePassword_FormInputContainer__fwACK"};